import { __assign, __rest } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/swiper-item/swiper-item.tsx
 */
import React from "react";
import classNames from "classnames";
export var SwiperItem = React.forwardRef(function SwiperItem(_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ ref: ref, className: classNames("swiper-slide", className) }, props)));
});
//# sourceMappingURL=SwiperItem.js.map